import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'trp-community-widget',
  standalone: true,
  imports: [],
  templateUrl: './community-widget.component.html',
  styleUrls: ['./community-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommunityWidgetComponent {}
